import {Module} from "vuex";
import {RootState} from "@/store/index";

export interface CommonModuleState {
  isLoadProcessing: boolean;
  modalInfo: {
    [key: string]: string;
  };
  modalActive: {
    [key: string]: boolean;
  };
}

const commonModuleData = (): CommonModuleState => {
  return {
    isLoadProcessing: false,
    modalInfo: {
      title: "알림",
      content: "",
    },
    modalActive: {
      alert: false,
      formLogin: false,
      formJoin: false,
      formModifyProfile: false,
      formQna: false,
      confirmLogout: false,
      confirmBoardDelete: false,
      alertJoinComplete: false,
      alertContactUsComplete: false,
      alertEpisodeContentsView: false,
      alertContractView: false,
      alertContactUsPolicy: false,
      alertPolicy: false,
    },
  };
};

export const CommonModule: Module<CommonModuleState, RootState> = {
  namespaced: true,
  state: commonModuleData(),
  mutations: {
    setIsLoadProcessing(state, value: boolean): void {
      state.isLoadProcessing = value;
    },
    setOpenModal(state, payload?: string): void {
      for (const [i, v] of Object.entries(state.modalActive)) {
        if (v) state.modalActive[i] = false;
      }

      if (payload) state.modalActive[payload] = true;
    },
    setModalActive(state, payload: {keyName: string; value: boolean}): void {
      state.modalActive[payload.keyName] = payload.value;
    },
    setModalInfo(state, payload: {title: string; content: string}): void {
      state.modalInfo.title = payload.title;
      state.modalInfo.content = payload.content;
    },
  },
  getters: {},
  actions: {},
};
